import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import ChatWidget from "../../../features/ACS-Dashboard-Modules/AiChat/components/ChatWidget";
import { AppToastContainer } from "../ACS-Blocks/Toast";
import { useSessionExpiry, expireSession } from "../../../hooks/useSessionExpiry";
import SessionExpiryModal from "../ACS-Blocks/SessionExpiryModal";
import NotFoundPage from "../../../features/ACS-Auth/NotFoundPage";
import { isUnknownDashboardRoute } from "../../../routes/dashboardPaths";

const DashboardLayout = () => {
    const location = useLocation();
    const { showWarning, secondsLeft, isRefreshing, handleExtendSession, formatCountdown } = useSessionExpiry();
    const isAuthenticated = Boolean(Cookies.get("authToken"));
    const showNotFound = isUnknownDashboardRoute(location.pathname);

    if (showNotFound && !isAuthenticated) {
        return <NotFoundPage />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

  return (
    <div className="w-screen h-screen min-h-screen flex overflow-hidden">
      {/* One global toast container for the whole dashboard */}
      <AppToastContainer />

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex flex-col flex-1 min-w-0">
        <Header />
       <main className="flex-1 bg-[#F8FAFF] dark:bg-[#1E293B] font-roboto  overflow-hidden transition-none">
        {showNotFound ? (
          <NotFoundPage inDashboard />
        ) : (
          <Outlet key={location.pathname} />
        )}
      </main>
      </div>

      {/* AI Chat Widget - visible on all dashboard pages */}
      <ChatWidget />

      {/* Session expiry warning */}
      {showWarning && (
        <SessionExpiryModal
          secondsLeft={secondsLeft}
          isRefreshing={isRefreshing}
          onExtend={handleExtendSession}
          onLogout={expireSession}
          formatCountdown={formatCountdown}
        />
      )}
    </div>
  );
};

export default DashboardLayout;
